import Textfield from "@atlaskit/textfield";
import type {ComponentProps} from "react";

export function AnankeTextField(
    props: ComponentProps<typeof Textfield> & {
        label?: undefined;
    },
) {
    return <Textfield {...props} />;
}
